document.addEventListener('turbo:load', function () {
  // Initial page load is tracked by Fathon
  // Subsequent Turbo loads are tracked here
  if (Fathom.isInitialPageLoad) {
    Fathom.isInitialPageLoad = false;
    return;
  }

  if (window.fathom) {
    window.fathom.trackPageview();
  }
});

var Fathom = {
  isInitialPageLoad: true,
  
  trackEvent: function(name, value) {
    if (window.fathom) {
      window.fathom.trackEvent(name, { _value: value });
    }
  }
}

window.Fathom = Fathom;